import { render, staticRenderFns } from "./BackNewYear.vue?vue&type=template&id=664f069f&scoped=true"
import script from "./BackNewYear.vue?vue&type=script&lang=js"
export * from "./BackNewYear.vue?vue&type=script&lang=js"
import style0 from "./BackNewYear.vue?vue&type=style&index=0&id=664f069f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f069f",
  null
  
)

export default component.exports